import { Dispatch, SetStateAction } from "react";
import { ICart } from "@features/cart/ICart";
import { EServiceGroup } from "@constants";
import { IEirSalesAscertain } from "@modules/eirSalesFacade/interfaces/models/IEirSalesAscertain";
import { checkCartOfferByServiceGroup } from "@utils/offerUtils";

interface IParams {
    ascertain: IEirSalesAscertain;
    setCart: Dispatch<SetStateAction<ICart | undefined>>;
}

export const updateCartWithAscertain = (props: IParams) => {
    const { ascertain, setCart } = props;

    setCart((currentCart) => {
        if (!currentCart) {
            return currentCart;
        }

        const updatedCart: ICart = {
            ...currentCart,
            offers: currentCart.offers.map((offer) => {
                if (checkCartOfferByServiceGroup(offer, EServiceGroup.SA_BB)) {
                    if (ascertain.appointmentType) {
                        return {
                            ...offer,
                            appointment: {
                                type: ascertain.appointmentType,
                                at: undefined,
                                time: undefined,
                            },
                        };
                    }

                    return {
                        ...offer,
                        appointment: undefined,
                    };
                }

                return offer;
            }),
        };

        return updatedCart;
    });
};
